import React from 'react';
import { Col, ListGroup, Row } from 'react-bootstrap';
import FormattedDateTime from '../../../../../components/datetime/FormattedDateTime';
import { useTranslation } from 'react-i18next';
import { BreakStarted } from '../../../hooks/useCurrentTimeTrackingTimeline';
import { useBreakTypes } from '../../../hooks/timeTracking/useBreakTypes';
import { getBreakTypeName } from '../../../components/BreakTypeIcon';
import FlairIcon from '../../../../../atomic/atoms/FlairIcon';

type Props = {
  step: BreakStarted;
};

const BreakStartedStep: React.FC<React.PropsWithChildren<Props>> = ({
  step,
}) => {
  const { t } = useTranslation();
  const breakTypes = useBreakTypes();
  const breakTypeName = getBreakTypeName(breakTypes, step.breakTypeId);
  return (
    <ListGroup.Item>
      <Row>
        <Col className="col-auto">
          <div className="avatar avatar-sm">
            <div className="avatar-title fs-3 bg-primary-soft rounded-circle text-primary">
              <FlairIcon icon="arrow-back-outline" className="me-2" />
            </div>
          </div>
        </Col>
        <Col className="ms-n2">
          <h5 className="mb-1">
            {breakTypeName
              ? t('timeTracking.current.steps.breakStarted.titleWithType', {
                  type: breakTypeName,
                })
              : t('timeTracking.current.steps.breakStarted.title')}
          </h5>

          <small className="text-dark">
            <FormattedDateTime dateTime={step.time} format="time" />
          </small>
        </Col>
      </Row>
    </ListGroup.Item>
  );
};

export default BreakStartedStep;
